import keyMirror from 'keymirror';

const CARD_TYPES = keyMirror({
  MASTER: null,
  VISA: null,
  AMEX: null,
  CARNET: null,
  JCB: null,
  EMD_VOUCHER: null,
  EMD_VOUCHER_TDD_TDC: null,
  EMD_VOUCHER_UATP: null,
});

export default CARD_TYPES;
